import Vue from "vue"

import resetMixin from "~/mixins/store/resetToInitialState"

import picture_build_helper from "~/helpers/images/picture_build"

const initialState = function () {
  return {
    authorized: false,
    good_critic: false,
    trusted: false,
    visible: false,
    has_profile_picture: false,
    has_banner: false,
    has_sendtrack_picture: false,
    is_scout: false,
    description: "",
    description_fr: "",
    description_en: "",
    entity: "",
    link: "",
    slug: "",
    service_details: "",
    service_details_en: "",
    service_details_fr: "",
    id: 0,
    date_joined: 0,
    display_score: 0,
    nb_feedbacks: 0,
    decisions: [],
    similar_artists: [],
    media_links: {},
  }
}

export const state = initialState

export const mutations = {
  SET: function (state, data) {
    const ignore_keys = ["tags"]

    for (let key in data) {
      if (typeof state[key] === typeof data[key] && !ignore_keys.includes(key))
        Vue.set(state, key, data[key])
    }
  },
  ...resetMixin.mutations,
}

export const actions = {
  FETCH({ dispatch, commit }) {
    return new Promise((resolve) => {
      Promise.all([dispatch("GET"), dispatch("tags/FETCH")])
        .then(([influencer]) => {
          if (influencer) commit("SET", influencer)
          resolve(influencer)
        })
        .catch(() => resolve(null))
    })
  },
  FORCE_PICTURE_REFRESH({ commit, state }) {
    commit("SET", { has_profile_picture: !state.has_profile_picture })
    Vue.nextTick(() => {
      commit("SET", { has_profile_picture: !state.has_profile_picture })
    })
  },
  GET: async function () {
    try {
      return await this.$axios.$get("/influencer/influencer/self/")
    } catch (err) {
      return null
    }
  },
  RESET: async function ({ commit, dispatch }) {
    dispatch("tags/RESET")
    commit("RESET", initialState())
  },
}

export const getters = {
  GET_PICTURE(state) {
    return function ({ target, size }) {
      if (!size) size = "400_400"
      if (!target) target = "profile_picture"
      return picture_build_helper({
        kind: "influencer",
        slug: state.has_profile_picture ? state.slug : undefined,
        size,
        target,
      })
    }
  },
}
